"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGamesList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all games.
 *
 * ### Filter options
 *
 * - `tier` - filters by game tier,
 * - `isCurated` - filters by game's Steam curation status.
 *
 * ### Sort options
 *
 * - `tier` - sorts by game tier,
 * - `achievementsTotal` - sorts by game's number of achievements.
 *
 * ## Usage
 *
 * ```ts
 * const gamesAll: Game[] = await sdk.getGamesList({ });
 * const gamesByTier: Game[] = await sdk.getGamesList({ sort: { tier: 'asc' }});
 * const gamesCurated: Game[] = await sdk.getGamesList({ filter: { isCurated: true }});
 * ```
 *
 * @param params.filter - Filter to apply to returned game list.
 * @param params.sort - Fields to sort game list by.
 * @param params.limit - How many games will get returned.
 */
const getGamesList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { filter, sort, limit } = params;
    const url = `${BASE_URL}/games/list`;
    const gamesResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = gamesResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getGamesList = getGamesList;
